export const countries = [
  'Chile',
  'Kuwait',
  'Bahrain',
  'Oman',
  'Jordan',
  'United Kingdom',
  'Ireland',
  'Spain',
  'Belgium',
  'Finland',
  'France',
  'Greece',
  'Germany',
  'Italy',
  'Luxembourg',
  'Netherlands',
  'Portugal',
  'Puerto Rico',
  'The United States',
  'Bermuda',
  'Panama',
  'Switzerland',
  'Canada',
  'Libya',
  'Australia',
  'New Zealand',
  'Azerbaijan',
  'Bosnia',
  'Bulgaria',
  'Aruba',
  'Barbados',
  'Fiji',
  'Dominican Republic',
  'Tunisia',
  'Georgia',
  'Peru',
  'Israel',
  'Qatar',
  'United Arab Emirates',
  'Saudi Arabia',
  'Poland',
  'Brazil',
  'Romania',
  'Ghana',
  'Turkey',
  'Croatia',
  'Denmark',
  'Greenland',
  'Bolivia',
  'China',
  'Hong Kong',
  'Norway',
  'Norway',
  'Morocco',
  'Sweden',
  'Venezuela',
  'Seychelles',
  'South Africa',
  'Namibia',
  'Maldives',
  'Egypt',
  'Moldova',
  'Mexico',
  'The Czech Republic',
  'Ukraine',
  'Thailand',
  'Taiwan',
  'Uruguay',
  'Nicaragua',
  'Mauritius',
  'Philippines',
  'Gambia',
  'Macedonia',
  'Russia',
  'India',
  'Afghanistan',
  'Bangladesh',
  'Kenya',
  'Serbia',
  'CPF',
  'Japan',
  'Iceland',
  'Jamaica',
  'Pakistan',
  'Hungary',
  'Nigeria',
  'Kazakhstan',
  'Armenia',
  'Costa Rica',
  'Central Africa',
  'Korea, Republic',
  'Iraq',
  'Lebanon',
  'Colombia',
  'Uganda',
  'Cambodia',
  'Paraguay',
  'Vietnam',
  'Iran',
];
